var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { Para } from "@irati/ui/src/Labels";
import Hr from "@irati/ui/src/Layout/Hr";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
import { Wrapper, SpacedPara, SpacedDiv, Link } from "../styled";
export var Variant;
(function (Variant) {
    Variant["SelfServe"] = "SELFSERVE";
    Variant["ITDepartment"] = "ITDEPARTMENT";
})(Variant || (Variant = {}));
var Instructions = /** @class */ (function (_super) {
    __extends(Instructions, _super);
    function Instructions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Instructions.prototype.render = function () {
        var _a = this.props, variant = _a.variant, formatMessage = _a.formatMessage;
        var helpLink = (React.createElement(Link, { href: formatMessage({ id: "setup_tenant.steps.whitelist.helplink.href" }), target: "_blank" },
            React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.helplink.text" })));
        switch (variant) {
            case Variant.SelfServe:
                return (React.createElement(Wrapper, null,
                    React.createElement(SpacedPara, { center: true, large: true },
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.intro.shared" }),
                        React.createElement("br", null),
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.intro.selfserveWithLink", values: { link: helpLink } })),
                    React.createElement(Hr, null),
                    React.createElement(Flex, { justifyContent: "space-between" },
                        React.createElement("div", null,
                            React.createElement(Para, { large: true },
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.title" })),
                            React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.domain1" }),
                            React.createElement("br", null),
                            React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.domain2" }),
                            React.createElement("br", null),
                            React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.domain3" }),
                            React.createElement("br", null),
                            React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.domain4" })),
                        React.createElement("div", null,
                            React.createElement(Para, { large: true },
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.ip.title" })),
                            React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.ip.ip1" }),
                            React.createElement("br", null),
                            React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.ip.ip2" })),
                        React.createElement("div", null,
                            React.createElement(CopyToClipboard, { text: formatMessage({ id: "setup_tenant.steps.whitelist.main.shared.clipboardtext" }) },
                                React.createElement(Button, null,
                                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.button" })))))));
            case Variant.ITDepartment:
                return (React.createElement(Wrapper, null,
                    React.createElement(SpacedPara, { center: true, large: true },
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.intro.shared" }),
                        React.createElement("br", null),
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.intro.itWithLink", values: { link: helpLink } })),
                    React.createElement(Hr, null),
                    React.createElement(Flex, { justifyContent: "space-between" },
                        React.createElement(SpacedDiv, null,
                            React.createElement(Para, null,
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.it.part1" })),
                            React.createElement(Para, null,
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.it.part2" })),
                            React.createElement(Para, null,
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.title" }),
                                " ",
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.domain1" }),
                                ",",
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.domain2" }),
                                ",",
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.domain3" }),
                                ",",
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.domains.domain4" })),
                            React.createElement(Para, null,
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.ip.title" }),
                                " ",
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.ip.ip1" }),
                                ",",
                                React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.ip.ip2" }))),
                        React.createElement("div", null,
                            React.createElement(CopyToClipboard, { text: formatMessage({ id: "setup_tenant.steps.whitelist.main.it.clipboardtext" }) },
                                React.createElement(Button, null,
                                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.whitelist.main.shared.button" })))))));
        }
    };
    return Instructions;
}(PureComponent));
export default injectIntl(Instructions);
